define(function (require) {

    var BaseApiService = require('web-agent-utils/BaseApiService');

    lpTag.AgentSessionVisit = function (baseUrl) {
        this.applicationType = "AgentSessionVisit";
//    var logger = lpTag.WebAgent.WebAgentLogger.getLogger(this.applicationType);

        var agentSessionVisitApiResource, getSingleAdditionalUrl;

        if (baseUrl) {
            var resourceDomainUrl = baseUrl.substring(0, baseUrl.indexOf('.json')) + '/';
            //TODO: Check with Liron where to get this URL correctly
            getSingleAdditionalUrl = "visits/visit?visitorId={visitorId}&v=1&data=true";
            agentSessionVisitApiResource = BaseApiService.createInstance({domainUrl: resourceDomainUrl, postmessagePath: "/postmessage", serviceName: this.applicationType});
        }

        function _createRequest(reqObj, visitorId, visitSessionKey) {
            reqObj.method = 'GET';
            reqObj.additionalUrl = getSingleAdditionalUrl.replace("{visitorId}", visitorId + "");
            if (visitSessionKey) {
                reqObj.additionalUrl = reqObj.additionalUrl.replace('?', '/' + visitSessionKey + '?');
            }
            reqObj.callingFunction = 'getVisit';
            return reqObj;
        }

        this.getRequest = function (reqObj, visitorId, visitSessionKey) {
            reqObj = _createRequest(reqObj, visitorId, visitSessionKey);
            var fullRequest = agentSessionVisitApiResource.createBasicRequest(reqObj);
            fullRequest.polling = true;
            return fullRequest;
        };

        this.getVisit = function (reqObj, visitorId, visitSessionKey) {
            reqObj = _createRequest(reqObj, visitorId, visitSessionKey);
            reqObj.callingFunction = 'getVisit';
            agentSessionVisitApiResource.sendRequest(reqObj);
        };
    };

    return lpTag.AgentSessionVisit;

});
